import React from 'react'

const ErrorPageLayout = ({ children }) => {
    return (
        <div className="main-wrap" onContextMenu={(e)=> e.preventDefault()}>
            {children}
        </div>
    )
}

export default ErrorPageLayout
